import React from 'react';
import { Navigate } from 'react-router-dom';
import { useGlobal } from './utils/GlobalContext'; // adjust import as needed

interface RequireRoleProps {
  roles: string[];
  redirectTo?: string;
  children: React.ReactNode;
}

const RequireRole: React.FC<RequireRoleProps> = ({
  roles,
  redirectTo = "/",
  children,
}) => {
  const { state } = useGlobal();
  const userRoles = state.UserProfile.RolesList || [];

  const hasRequiredRole = roles.some((role) => userRoles.includes(role));

  return hasRequiredRole ? (
    <>{children}</>
  ) : (
    <Navigate to={redirectTo} replace />
  );
};

export default RequireRole;
